/** Find a person by name, phone or email, and pick them. For forms that need "who is this for". */
import type { ContactSummary } from "@tlcrm/shared";
import { formatPhone } from "@tlcrm/shared";
import { useState } from "react";

import { useSearch } from "../api/hooks";

export function ContactPicker({
  value,
  onChange,
  id,
  invalid,
}: {
  value: ContactSummary | null;
  onChange: (c: ContactSummary | null) => void;
  id?: string;
  invalid?: boolean;
}) {
  const [q, setQ] = useState("");
  const search = useSearch(q);
  if (value) {
    return (
      <div className="picked">
        <span className="truncate">
          <b>{value.fullName}</b>
          {value.primaryPhone && (
            <span className="mono t3"> {formatPhone(value.primaryPhone)}</span>
          )}
        </span>
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => onChange(null)}>
          Change
        </button>
      </div>
    );
  }
  const matches = q.trim().length >= 2 ? (search.data?.contacts ?? []) : [];
  return (
    <div className="picker">
      <input
        id={id}
        className={`field${invalid ? " is-invalid" : ""}`}
        placeholder="Name, phone or email"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        autoComplete="off"
      />
      {matches.length > 0 && (
        <div className="menu picker-menu" role="listbox">
          {matches.slice(0, 8).map((c) => (
            <button
              key={c.id}
              type="button"
              role="option"
              aria-selected={false}
              className="menu-item"
              onClick={() => onChange(c)}
            >
              <span className="truncate">{c.fullName}</span>
              {c.primaryPhone && <span className="mono t3">{formatPhone(c.primaryPhone)}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
